<template>
  <div class="tooltip_hv">
    <div><ve-ring :data="circularGraphData"></ve-ring></div>
    <div><span>会计核算岗：</span>{{data.会计核算岗}}%</div>
    <div><span>票据岗：</span>{{data.票据岗}}%</div>
    <div><span>税务岗：</span>{{data.税务岗}}%</div>
    <div><span>出纳岗：</span>{{data.出纳岗}}%</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: function(){
        return {
          会计核算岗: 1,
          票据岗: 2,
          税务岗: 3,
          出纳岗: 4,
        }
      }
    }
  },
  data() {
    return {
      circularGraphData: {
        columns: ['日期', '访问用户'],
        rows: [
          { '日期': '1/1', '访问用户': 1393 },
          { '日期': '1/2', '访问用户': 3530 },
          { '日期': '1/3', '访问用户': 2923 },
          { '日期': '1/4', '访问用户': 1723 },
          { '日期': '1/5', '访问用户': 3792 },
          { '日期': '1/6', '访问用户': 4593 }
        ]
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/student/tooltip.vue